import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { ApiResponseData } from "../../services/YourAppServer/YourAppServerApi.service";

export class CouponViewModel {
  public id: number;
  public release: boolean;
  public public: boolean;
  public momentFromDate: Moment; // for sorting
  public startDate: string;
  public startDayMonth: string;
  public startYear: string;
  public endDate: string;
  public endDayMonth: string;
  public endYear: string;
  public label_de?: string;
  public label_en?: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public text_de: string;
  public text_en: string;
  public get text(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.text_en) ? this.text_de : this.text_en;
  }
  public image_photo: string;
  public locations: number[];
  public like: boolean;
  public anonym_code: boolean;
  public isRedeemed: boolean = false;
  public isRedeemOncePerUser: boolean = false;
}

export class CouponDetailViewModel {
  public id: number;
  public release: boolean;
  public public: boolean;
  public momentFromDate: Moment; // for sorting
  public startDate: string;
  public startTime: string;
  public endDate: string;
  public endTime: string;
  public label_de?: string;
  public label_en?: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public text_de: string;
  public text_en: string;
  public get text(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.text_en) ? this.text_de : this.text_en;
  }
  public image_photo: string;
  public locations: number[];
  public rate: number;
  public like: boolean;
  public qrCodeUrl: string;
  public qrCodeText: string;
  public anonym_code: boolean;
  public isRedeemed: boolean = false;
  public isRedeemOncePerUser: boolean = false;
  public coupon_code: string = "";
}

// Requests
export class CouponSyncModel extends SyncModel {
}

// Responses
export class CouponDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public release: boolean;
  public public: boolean;
  public date_ymd: number;
  public get date(): Moment {
    return Utils.GetMomentFromInt(this.date_ymd, 0);
  }
  public end_date_ymd: number;
  public get end_date(): Moment {
    return Utils.GetMomentFromInt(this.end_date_ymd, 0);
  }
  public label_de: string;
  public label_en: string;
  public text_de: string;
  public text_en: string;
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  public get last_image_update_at(): Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  public locations: number[];
  public qr_code_url: string;
  public qr_code_text: string;
  public anonym_code: boolean;
  public deleted: boolean;
  public change_at_ymd: number;
  // Portal flag RedeemOncePerUser; may be null/undefined (guard to false)
  public redeem_once_per_user?: boolean;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class CouponSyncDataModel extends SyncDataModel {
  public coupons: CouponDataModel[];
  public get models(): DataModel[] { return this.coupons; }
  public DeserializeType(): void {
    this._DeserializeType(CouponDataModel);
  }
}

// api/coupon/ReserveRedemption — the server sends the fields directly, without the usual data wrapper
export interface ReserveCouponRedemptionRequestModel {
  coupon_id: number;
  /** hyp_cus_nr for the reservation; omitted when no order-mode location is known. */
  hyp_cus_nr?: number;
  source: number;
  /** Order type for the reservation; undefined together with hyp_cus_nr when there's no order-mode context. */
  order_type?: number;
}

export class ReserveCouponRedemptionResponseModel implements ApiResponseData {
  public success: boolean = false;
  public error: string = "";
  public redemption_id: number;
  /** Redemption PIN from the Reserve response — NOT the product-linking qr_code_text. */
  public code: string = "";
  public expires_at_ymd: number;
  public expires_at_hms: number;
  public product_id?: number;
  public DeserializeType(): void { /* flat response, no nested type to cast */ }
}

// api/coupon/ReleaseRedemption — fields come directly, without the data wrapper
export interface ReleaseCouponRedemptionRequestModel {
  redemption_id: number;
}

export class ReleaseCouponRedemptionResponseModel implements ApiResponseData {
  public success: boolean = false;
  public error: string = "";
  public DeserializeType(): void { /* flat response */ }
}

// api/coupon/GetRedeemedCoupons — fields come inside the usual data wrapper, like GetNewCoupons
export class RedeemedCouponDataModel {
  public coupon_id: number;
  public status: number;
  public changed_at_ymd: number;
  public changed_at_hms: number;
}

export class GetRedeemedCouponsSyncModel extends SyncModel {
}

export class GetRedeemedCouponsResponseModel implements ApiResponseData {
  public redeemed_coupons: RedeemedCouponDataModel[] = [];
  public DeserializeType(): void { /* flat elements, no DataModel cast needed */ }
}
